/* eslint-disable import/prefer-default-export */

class SettlementOfferModelConsts {
  public static readonly DescriptionMaxLength: number = 100;

  public static readonly CurrencyLength: number = 3;
}

export default SettlementOfferModelConsts;
